import * as awdCustom from './functions.js';

let scrl;

document.addEventListener("DOMContentLoaded", function(){

	scrl = awdCustom.customScrollPage()

	awdCustom.ScrollBarCustom(scrl)
	awdCustom.HeaderFunction()
	new awdCustom.mousePointer
	new awdCustom.Home
	
});